import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mensaje-ceo',
  templateUrl: './mensaje-ceo.component.html',
  styleUrls: ['./mensaje-ceo.component.scss']
})
export class MensajeCeoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
